import { gql } from '__generated__'

export const GET_ACTIVE_USERS = gql(`
  query getCurrentOnline {
    getCurrentOnline
  }
`)
